import { render, staticRenderFns } from "./LoginMFACode.vue?vue&type=template&id=404b1fa8&scoped=true&"
import script from "./LoginMFACode.vue?vue&type=script&lang=js&"
export * from "./LoginMFACode.vue?vue&type=script&lang=js&"
import style0 from "./LoginMFACode.vue?vue&type=style&index=0&id=404b1fa8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404b1fa8",
  null
  
)

export default component.exports